export default {"src":"/_next/static/media/modal-close-icon.4fc39958.svg","height":68,"width":68};